import Brands from "../components/LandingPage/Brands";
import FeatureCard from "../components/LandingPage/FeatureCard";
import Delfraser from "../components/LandingPage/FeatureSections/Delfraser";
import Frasebiblotek from "../components/LandingPage/FeatureSections/Frasebiblotek";
import MakroFunktion from "../components/LandingPage/FeatureSections/MakroFunktion";
import PersonligeFraser from "../components/LandingPage/FeatureSections/PersonligeFraser";
import Journalføring from "../components/LandingPage/FeatureSections/Journalføring";
import HeroSection from "../components/LandingPage/HeroSection";
import Stats from "../components/LandingPage/Stats";
import TeametBag from "../components/LandingPage/TeametBag";
import Testimonials from "../components/LandingPage/Testimonials";
import UseCases from "../components/LandingPage/UseCases";
import PublicLayout from "../layout/PublicLayout";
import { useRef } from "react";

function LandingPage() {
  const htmlRef1 = useRef<HTMLDivElement>(null);
  const htmlRef2 = useRef<HTMLDivElement>(null);
  const htmlRef3 = useRef<HTMLDivElement>(null);
  const htmlRef4 = useRef<HTMLDivElement>(null);

  const lottieRef1 = useRef<any | null>(null);
  const lottieRef2 = useRef<any | null>(null);
  const lottieRef3 = useRef<any | null>(null);
  const lottieRef4 = useRef<any | null>(null);

  const pauseAllLottieExcept = (lottieRef: any) => {
    if (lottieRef1.current && lottieRef1.current !== lottieRef) {
      lottieRef1.current.pause();
    }

    if (lottieRef2.current && lottieRef2.current !== lottieRef) {
      lottieRef2.current.pause();
    }

    if (lottieRef3.current && lottieRef3.current !== lottieRef) {
      lottieRef3.current.pause();
    }

    if (lottieRef4.current && lottieRef4.current !== lottieRef) {
      lottieRef4.current.pause();
    }
  };

  return (
    <PublicLayout>
      <HeroSection />
      <Stats />
      <UseCases />
      <div className="mb-10">
        <FeatureCard />
      </div>
      <TeametBag />
      <section className="bg-doctio-lightgreen pb-0 md:pb-12 md:pt-12 mb-0 md:mb-48">
        <Frasebiblotek />
        <PersonligeFraser
          pauseAll={pauseAllLottieExcept}
          lottieRef={lottieRef1}
          htmlRef={htmlRef1}
        />
        <MakroFunktion
          pauseAll={pauseAllLottieExcept}
          lottieRef={lottieRef2}
          htmlRef={htmlRef2}
        />
        <Delfraser
          pauseAll={pauseAllLottieExcept}
          lottieRef={lottieRef3}
          htmlRef={htmlRef3}
        />
        <Journalføring
          pauseAll={pauseAllLottieExcept}
          lottieRef={lottieRef4}
          htmlRef={htmlRef4}
        />
      </section>
      <div className="testimonials mt-10">
        <Testimonials />
      </div>
      <Brands />
    </PublicLayout>
  );
}

export default LandingPage;
